// Fallback required by Expo Router when platform extensions (.native.tsx, .web.tsx) are used.
// Both platforms have dedicated implementations, so this should never render.
import { Redirect } from "expo-router";

export default function ClipsFallback() {
  return <Redirect href="/overview" />;
}
